import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { OnboardProviderBody } from "@shared-kernel/application/ports/shared/shared-repository";

export const onboardProvider = createApiThunk<void, OnboardProviderBody>(
  "users/onboardProvider",
  async (body, { extra: { sharedRepository } }) => {
    return sharedRepository!.onboardProvider(body);
  },
);

export const resetOnboardProvider = createAction("users/resetOnboardProvider");
